
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SalesTable from '@/components/sales/SalesTable.vue';
import VWrapper from '@/components/shared/VWrapper.vue';
import { SalesOverview as SalesItem } from '@/interfaces/models/SalesOverview';
import Filter from '@/interfaces/api/Filter';
import { User } from '@/interfaces/models/User';
import VRangePicker from '@/components/shared/form/VRangePicker.vue';
import SalesOverviewTable from '@/components/salesOverview/SalesOverviewTable.vue';
import OrderServiceApi from '@/api/http/OrderServiceApi';
import Notification from '@/mixins/Notification';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import { toUrl } from '@/util/helper';
import moment from 'moment';

const salesOverview = namespace('salesOverview');
const auth = namespace('auth');

@Component({
  components: { VRangePicker, SalesOverviewTable, VWrapper },
})
export default class SalesOverview extends mixins(Notification) {
  public $refs!: {
    table: SalesTable & { resetPage: () => void };
  };

  @salesOverview.State('items') public items!: SalesItem[];
  @salesOverview.State('filter') public filter!: Filter;
  @salesOverview.State((state) => state.pagination.total) public total!: number;
  @auth.State('user') public authUser!: User;

  @salesOverview.Action('fetch') public getSales: any;
  @salesOverview.Action('setFilter') public setFilter: any;
  @salesOverview.Action('reset') public reset: any;

  get isDeanAndDavid() {
    if (this.$isAdmin()) {
      return true;
    }

    if (
      this.authUser?.customerGroup !== CustomerGroupEnum.DeanAndDavid &&
      this.authUser?.linkedCustomerGroup !== CustomerGroupEnum.DeanAndDavid
    ) {
      return false;
    }

    return true;
  }

  public beforeMount() {
    this.reset();
  }

  public async onSearch(queries: { customerGroup: string; from: string; to: string }) {
    if (!this.isValidSearchQuery(queries)) {
      return;
    }

    try {
      this.$startLoading('salesOverview');
      this.setFilter(queries);
      await this.getSales();
    } finally {
      this.$stopLoading('salesOverview');
    }
  }

  public async exportSales() {
    this.$startLoading('exportSales');
    const api: OrderServiceApi = new OrderServiceApi();

    api
      .salesOverview({ ...(this.filter as { customerGroup: string; from: string; to: string }) })
      .then((res: AxiosResponse<string>) => {
        toUrl(res.data, `sales-${moment().format('DD-MM-YYYY')}.xlsx`);
        this.notifyInfo('notification.downloadInProgress');
      })
      .finally(() => {
        this.$stopLoading('exportSales');
      });
  }

  private isValidSearchQuery(queries: { customerGroup: string; from: string; to: string }): boolean {
    const { from, to } = queries;
    return Boolean(from) || Boolean(to);
  }
}
